module.exports = __webpack_public_path__ + "static/media/androidLogo.6500f189.svg";